import {
	AspectRatioContainer,
	Container,
	Text,
	ContainerPadding,
	Image,
	TextAlignment,
	TokenTextAppearance,
	Richtext,
	TokenTextColor,
	List,
	ListItem,
	ContainerGutter,
} from '@volkswagen-onehub/components-core';
import * as React from 'react';
import styled from 'styled-components';
import { IMAGE_DEFAULT_VWLOGO } from '../../../../vw-logo';

const ClubCardContainer = styled.div<{ index: number; numberOfCards: number }>`
	height: 100%;
	position: relative;
	backdrop-filter: blur(10px);
	border-radius: 16px;
	background: rgba(255, 255, 255, 0.7); /* 0.7 is the opacity for the background color */

	margin: 0 var(--size-grid001);

	@media screen and (min-width: 960px) {
		margin-right: ${(props) => (props.index === props.numberOfCards - 1 ? 'calc(var(--size-grid001) / 5)' : '0')};
	}

	margin-bottom: var(--size-dynamic0250);

	/* Shadow04 */
	box-shadow:
		0px 8px 24px 0px rgba(0, 14, 38, 0.05),
		0px 4px 16px 0px rgba(0, 14, 38, 0.1);
`;

const MinHeightTitleContainer = styled.div`
	padding-top: var(--size-dynamic0020);

	@media screen and (min-width: 560px) {
		min-height: 53px;
	}

	@media screen and (min-width: 1280px) {
		min-height: 57px;
	}
`;

const MinHeightListContainer = styled.div`
	min-height: 115px;
`;

interface CardDetail {
	title: string;
	text: string;
	image: string;
	description: string[];
}

export const ClubCard = ({
	cardDetail,
	index,
	numberOfCards,
}: {
	cardDetail: CardDetail;
	index: number;
	numberOfCards: number;
}): React.ReactElement => {
	return (
		<ClubCardContainer className="club-card-container" index={index} numberOfCards={numberOfCards}>
			<Container horizontalAlign={'center'} wrap="always">
				<AspectRatioContainer data-testid="aspect-ratio-container" ratio="3:2">
					<Image
						src={cardDetail.image || IMAGE_DEFAULT_VWLOGO}
						objectFit="cover"
						alt="Voucher_image"
						style={{ borderRadius: '16px' }}
					/>
				</AspectRatioContainer>

				<Container
					wrap={'always'}
					padding={{
						top: ContainerPadding.dynamic0100,
						right: ContainerPadding.static250,
						bottom: ContainerPadding.dynamic0130,
						left: ContainerPadding.static250,
					}}
				>
					<Text appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.start}>
						{cardDetail.text}
					</Text>
					<MinHeightTitleContainer>
						<Text appearance={TokenTextAppearance.headline200} textAlign={TextAlignment.start}>
							<Richtext markdown={cardDetail.title} color={TokenTextColor.primary} />
						</Text>
					</MinHeightTitleContainer>
					<Container wrap={'always'} padding={{ top: ContainerPadding.dynamic0100 }}>
						<MinHeightListContainer>
							<List gutter={ContainerGutter.static150}>
								{cardDetail.description.map((description, index) => (
									<ListItem key={index}>
										<Text appearance={TokenTextAppearance.copy200}>{description}</Text>
									</ListItem>
								))}
							</List>
						</MinHeightListContainer>
					</Container>
				</Container>
			</Container>
		</ClubCardContainer>
	);
};
